import { render, staticRenderFns } from "./ClientsMailsForDeliveringPage.vue?vue&type=template&id=6a0fb262"
import script from "./ClientsMailsForDeliveringPage.vue?vue&type=script&lang=js"
export * from "./ClientsMailsForDeliveringPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports